function VenueAccommodation() {
    return (
        <div>
            <h2>Venue and Accommodation</h2>
            <p className="no-newline-after-p">The IETBHEC'27 Organising Committee has negotiated an exclusive contract with leading international 5-star hotels in Da Nang for registered conference participants. This will provide extremely reasonable and affordable room rates exclusively for IETBHEC'27 registered participants. The booking link and all relevant information will be available here in due course. Therefore, participants are strongly advised to stay at the recommended hotel, as the Conference Gala Banquet will be held at the hotel.</p>
            <br></br>
            <p>In addition, the options for budget hotel accommodation will be provided here in due course.</p>
            {/* <div className="px-5">
                <ol>
                    <li className="NoPaddingOrMargin">
                        <p>Ibis Budget Singapore West Coast (2 star)</p>
                        <p>Room category: Super room with 1 double bed (with window). No breakfast. Per room per night: $136 est</p>
                        <p>Distance: 8 mins by bus</p>
                    </li>
                    <br></br>
                    <li className="NoPaddingOrMargin">
                        <p>Ibis Budget Singapore Mount Faber (2 star)</p>
                        <p>Room category: Deluxe Theme room with 1 double bed (with window). No breakfast. Per room per night: $117 est</p>
                        <p>Distance: 20 mins by bus</p>
                    </li>
                    <br></br>
                    <li className="NoPaddingOrMargin">
                        <p>Hotel Faber Park Singapore (4 star)</p>
                        <p>Room category: Superior room with 1 double bed. No breakfast. Per room per night: $205 est</p>
                        <p>Distance: 20 mins by bus</p>
                    </li>
                    <br></br>
                    <li className="NoPaddingOrMargin">
                        <p>Travelodge Harbourfront (4 star)</p>
                        <p>Room category: Standard Queen. No breakfast. Per room per night: $186 est</p>
                        <p>Distance: 30 mins by bus</p>
                    </li>
                </ol>
            </div> */}
        </div>
    )
}

export default VenueAccommodation